/**
 * User Recommend Setup (V1)
 * Entry point / integration (DI)
 */

import { UserRecommendApi } from "./user-recommend-api";
import { UserRecommendHandler } from "./user-recommend-handler";
import { UserRecommendListener } from "./user-recommend-listener";
import { UserRecommendRender } from "./user-recommend-render";

export class UserRecommendSetup {
    public static init(): void {
        if (document.documentElement.dataset.userRecommendInit === "1") return;
        document.documentElement.dataset.userRecommendInit = "1";

        const render = new UserRecommendRender();
        const handler = new UserRecommendHandler({ api: UserRecommendApi, render });
        const listener = new UserRecommendListener({ handler });
        listener.register();
    }
}

export function initUserRecommendSystem(): void {
    UserRecommendSetup.init();
}
